import { SET_CURRENT_USER } from '../../Constants/ActionTypes'

export function setCurrentUser(user) {
  return {
    type: SET_CURRENT_USER,
    payload: user,
  }
}
